import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';

import { valueFromEvent, createRoute } from 'lib/util';
import { Form } from 'common/components';
import AssetsDepreciation from 'components/assets/depreciation';
import { calculateDepreciation } from 'containers/assets/actions';

class AssetsEditDepreciationView extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    asset: PropTypes.object.isRequired,
    inpcs: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = { endDate: moment() };

  componentWillMount = () => this.calculate();

  handleEndDateChange = (e) => {
    this.setState({ ...valueFromEvent(e) }, this.calculate);
  };

  calculate = () =>
    this.props.calculateDepreciation(this.state.endDate, this.props.asset, this.props.inpcs);

  render = () => (
    <Fragment>
      <AssetsDepreciation.Info asset={this.props.asset} />
      <AssetsDepreciation.EndDate
        startDate={this.props.asset.startDate}
        endDate={this.state.endDate}
        handleEndDateChange={this.handleEndDateChange}
      />
      {(this.props.asset._financialDepreciationResult && (
        <AssetsDepreciation.Detail
          title="assets.depreciation_financial"
          depreciation={this.props.asset._financialDepreciationResult}
        />
      )) || <AssetsDepreciation.Fail title="assets.depreciation_financial" />}
      {(this.props.asset._fiscalDepreciationResult && (
        <AssetsDepreciation.Detail
          title="assets.depreciation_fiscal"
          depreciation={this.props.asset._fiscalDepreciationResult}
        />
      )) || <AssetsDepreciation.Fail title="assets.depreciation_financial" />}
      {this.props.asset._extraDepreciationsResult &&
        this.props.asset._extraDepreciationsResult
          .filter((depreciation) => depreciation)
          .map((depreciation, index) => (
            <AssetsDepreciation.Detail
              title={depreciation.name}
              key={index}
              depreciation={depreciation}
            />
          ))}
      <div className="col-md-12 mt-3">
        <Form.Link
          to={createRoute(this.props.company.id, this.props.subcompany.id, 'assets')}
          className={classnames('btn btn-secondary pull-right mr-3')}
        >
          {this.props.t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { calculateDepreciation };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(AssetsEditDepreciationView));



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetsEditDepreciationSection.js